export default __webpack_public_path__ + "static/media/home.f2ebcce2.svg";